module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iJ6tr"))).then(() => parcelRequire('hEqeo'));